export default __webpack_public_path__ + "static/media/pic6.42f81537.jpg";